// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"6f2ee2dc","977":"e226f21b"}[chunkId] + ".chunk.js";
};